var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('header',[_c('img',{staticClass:"header_img",attrs:{"src":_vm.bg_img,"alt":"背景图"}})]),_c('img',{staticClass:"btn_img",attrs:{"src":require("../../assets/image/invite/btn.png"),"alt":""},on:{"click":_vm.to_miniprogram}})])
}
var staticRenderFns = []

export { render, staticRenderFns }